import { render, staticRenderFns } from "./BlockGallery.vue?vue&type=template&id=b5bac020&scoped=true&"
import script from "./BlockGallery.vue?vue&type=script&lang=js&"
export * from "./BlockGallery.vue?vue&type=script&lang=js&"
import style0 from "./BlockGallery.vue?vue&type=style&index=0&id=b5bac020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bac020",
  null
  
)

export default component.exports